import { Container, Row, Col } from 'react-bootstrap';
import { ForgotPasswordForm } from '../../../Components/forms/forgotpasswordform/ForgotPasswordForm';
import signupImage from '../../../assets/images/signup.jpg';
import logo from '../../../assets/images/logo.png';
import './forgotpassword.css';

export const ForgotPassword = () => {
  return (
    <div className="fp-page">
      <Container fluid className="h-100 p-0">
        <Row className="fp-row g-0">
          {/* Left — image panel */}
          <Col xs={12} md={6} className="fp-image-col d-none d-md-block">
            <img
              src={signupImage}
              alt="Medical professionals"
              className="fp-side-image"
            />
          </Col>

          {/* Right — form panel */}
          <Col xs={12} md={6} className="fp-form-col">
            <div className="fp-form-container">
              <img src={logo} alt="Bizaario Care" className="fp-logo" />
              <ForgotPasswordForm />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
